import { render, staticRenderFns } from "./LookMore.vue?vue&type=template&id=48a08f50&scoped=true&"
import script from "./LookMore.vue?vue&type=script&lang=js&"
export * from "./LookMore.vue?vue&type=script&lang=js&"
import style0 from "./LookMore.vue?vue&type=style&index=0&id=48a08f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a08f50",
  null
  
)

export default component.exports